<div class="separator">
  <span *ngIf="labelKey">{{ labelKey | translate }}</span>
  <hr>
</div>
